"use client";

import React, { useEffect } from "react";

import { Box, Button, CardContent, Typography } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";

import { RHFSelectEventType } from "@onair/ui/form-controls/select-event-type";
import { RHFSelectEventLocationType } from "@onair/ui/form-controls/select-event-location-type";
import { UseFormReturn, useWatch } from "react-hook-form";
import { WizardSchemaType } from "./index";
import CardWizard from "./card-wizard";

interface PropTypes {
	methods: UseFormReturn<WizardSchemaType>;
	isEdit?: boolean;
	onStart: () => void;
}

const StepType: React.FC<PropTypes> = ({
	methods,
	onStart,
	isEdit = false,
}) => {
	const { control, setValue } = methods;
	const type = useWatch({
		name: "type",
		control,
	});

	const locationType = useWatch({
		name: "locationType",
		control,
	});

	// Bind data for validation
	useEffect(() => {
		setValue(`stepTimelineAndPricing.locationType`, locationType, {
			shouldDirty: true,
			shouldValidate: true,
		});

		setValue(`stepPricing.locationType`, locationType, {
			shouldDirty: true,
			shouldValidate: true,
		});
	}, [locationType]);

	const canStart = type && locationType;

	return (
		<Box maxWidth={730} py={2} mx="auto">
			<CardWizard>
				<CardContent
					sx={{
						p: {
							xs: "0 !important",
							md: "32px !important",
						},
					}}
				>
					<Typography mb={4} variant="h4" fontWeight={700} textAlign="center">
						{isEdit ? "Chỉnh sửa" : "Tạo"} sự kiện
					</Typography>
					<RHFSelectEventLocationType name="locationType" />
					<RHFSelectEventType name="type" />

					<Box display="flex" mt={3} justifyContent="center">
						<Button
							variant="contained"
							color="primary"
							size="large"
							disabled={!canStart}
							onClick={onStart}
							endIcon={
								<Iconify
									width={24}
									icon="solar:double-alt-arrow-right-bold-duotone"
								/>
							}
							sx={{
								fontWeight: 700,
							}}
						>
							{isEdit ? "Chỉnh sửa" : "Bắt đầu"} ngay
						</Button>
					</Box>
				</CardContent>
			</CardWizard>
		</Box>
	);
};

export default StepType;
